import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { LwFormInput, LwFormMultiSelect } from 'redesign';
import { useGetFlexPoolsForCompany } from 'ogp/components/views/planning/flex-pools/flex-pool-create/hooks/use-get-flex-pools-for-company';
import { RenderUnsettledUI } from 'shared/components';
import { FlexPool } from 'hq/services/flex-pool-service.types';
import { FormMode } from 'shared/components/shift-forms/components/forms/shared/types';
import { useTranslation } from 'react-i18next';

export type EmployeeFormData = {
  email: string;
  firstName: string;
  infix?: string;
  lastName: string;
  employeeFlexPools: FlexPool[];
};

export const EmployeeForm = ({ formState }: { formState: FormMode }) => {
  const { control } = useFormContext<EmployeeFormData>();
  const flexPoolsQuery = useGetFlexPoolsForCompany();
  const { t } = useTranslation('all-platforms-common');

  if (flexPoolsQuery.status !== 'success') {
    return <RenderUnsettledUI data={flexPoolsQuery} />;
  }

  return (
    <form aria-label="Employee form">
      <Grid container item xs={9} spacing={2}>
        <Grid item xs={6}>
          {formState === 'create' && (
            <LwFormInput
              name="email"
              control={control}
              label={t('worker_data.email')}
              rules={{ required: 'Voer een email in' }}
            />
          )}
          <LwFormInput
            name="firstName"
            control={control}
            label={t('worker_data.first_name')}
            rules={{ required: 'Voer een voornaam in' }}
          />
          <LwFormInput name="infix" control={control} label={t('worker_data.infix')} />
          <LwFormInput
            name="lastName"
            control={control}
            label={t('worker_data.last_name')}
            rules={{ required: 'Voer een achternaam in' }}
          />
          {formState === 'update' && (
            <LwFormMultiSelect
              name="employeeFlexPools"
              control={control}
              options={flexPoolsQuery.data || []}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionKey={(option) => option.id}
              getOptionLabel={(option) => option.name}
              data-testid="employee-flexpools"
              label={t('flexpools.name')}
            />
          )}
        </Grid>
      </Grid>
    </form>
  );
};
